import { Container } from '../components/common';
import React from 'react';
import { media } from '../utils/styles';
import styled from 'styled-components';

const Banner = styled.div`
  background-size: cover;
  background-position: center;
  background-image: url(${({ $bgDesktop }) => $bgDesktop});
  padding: 52px 0;
  min-height: 180px;
  ${media.phone} {
    background-image: url(${({ $bgMobile }) => $bgMobile});
    min-height: 142px;
    padding: 24px 9px;
  }
  p {
    font-weight: 300;
  }
  strong {
    font-weight: 700;
  }
`;

const Heading = styled.div`
  font-size: 26px;
  line-height: 31px;
  color: #ffffff;
  ${media.phone} {
    font-size: 20px;
    line-height: 24px;
    width: 210px;
  }
`;

const Info = styled.div`
  margin-top: 16px;
  font-weight: 500;
  font-size: 20px;
  line-height: 29px;
  color: #ffffff;
  ${media.phone} {
    width: 210px;
    margin-top: 10px;
    font-size: 14px;
    line-height: 18px;
  }
`;

export const DiscountBanner = ({ banner, className }) => {
  return (
    <Banner
      className={className}
      $bgDesktop={banner.background_image_desktop.fluid.src}
      $bgMobile={banner.background_image_mobile.fluid.src}
    >
      <Container>
        <Heading dangerouslySetInnerHTML={{ __html: banner.banner_text.html }} />
        <Info dangerouslySetInnerHTML={{ __html: banner.info_text.html }} />
      </Container>
    </Banner>
  );
};
